import includes from 'lodash/includes'
import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import accessGroupMemberships from 'modules/dashboard/store/collections/AccessGroupMemberships'
import Group from 'modules/dashboard/store/models/communities/Group'

const Slugs = {
  announcements: 'announcements',
  celebrations: 'celebrations',
}

class Groups extends Collection<Group> {
  constructor(data: any = []) {
    super(data)
    makeObservable(this, {
      announcementsGroup: computed,
      fromCurrentUser: computed,
    })
  }

  model() {
    return Group
  }

  get announcementsGroup(): Group | null | undefined {
    return this.find({
      identifier: Slugs.announcements,
    })
  }

  get celebrationsGroup(): Group | null | undefined {
    return this.find({
      identifier: Slugs.celebrations,
    })
  }

  get fromCurrentUser(): Group[] {
    const accessGroupIds = accessGroupMemberships.map((model) => model.attributes.access_group_id)

    return this.models.filter((group) => includes(accessGroupIds, group.get('access_group_id')))
  }
}

export default new Groups()
